import { FC, createRef, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { StyledCommunityView } from '.'

const CommunityView: FC = () => {
  const iframeRef = createRef<HTMLIFrameElement>()
  const history = useHistory()

  useEffect(() => {
    const iframe = iframeRef.current

    if (!iframe) {
      return
    }

    const cleanedPath = history.location.pathname.split('/community/')[1]
    iframe.src = `https://hello.community.socialcurator.com/${cleanedPath || '?iframe=true'}`
  }, [iframeRef.current])

  useEffect(() => {
    window.addEventListener('message', handleIframeMessage, false)

    return () => {
      window.removeEventListener('message', handleIframeMessage, false)
    }
  }, [])

  const handleIframeMessage = (e: MessageEvent) => {
    const { event, title, url, path } = e.data

    if (event !== 'locationchange') {
      return
    }

    if (url && url.includes('hello.community.socialcurator')) {
      return window.location.replace(url)
    }

    if (url) {
      const formattedUrl = url.replace('hello.', 'app.')
      return window.location.replace(formattedUrl)
    }

    window.document.title = title

    if (path) {
      history.push(`/community${path}`)
    }
  }

  return (
    <StyledCommunityView>
      <iframe
        allow="camera;microphone;display-capture;fullscreen"
        src="https://hello.community.socialcurator.com/c/home?automatic_login=true"
        ref={iframeRef}
      />
    </StyledCommunityView>
  )
}

export default CommunityView
